export default __webpack_public_path__ + "static/media/maor-credit.fc4cabae.png";